module.exports = __webpack_public_path__ + "static/media/trip-1.b0d6ba82.png";